import { FC } from 'react';

import CreateToolbar, {
  TableToolbarProps,
} from '../../Table/Toolbars/CreateToolbar';
import { SERVICE_EXPORT_FILE_TYPES } from 'src/models/servise/constants';

const ServicesHistoryToolbar: FC<TableToolbarProps> = params => {
  return <CreateToolbar {...params} withOutCreate exportFileTypes={SERVICE_EXPORT_FILE_TYPES} />;
};

export default ServicesHistoryToolbar;
